import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonUpdatePassword.module.scss'

const ButtonUpdatePassword = () => {
  return (
    <div className={styles.buttonUpdateContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'update-password-button'}
            defaultMessage={'Update'}
          />
        )}
        customClassnames={{container: styles.button}}
      />
    </div>
  );
};

export default ButtonUpdatePassword;
